var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-mask" }, [
    _c("div", { staticClass: "modal-wrapper" }, [
      _c("div", { staticClass: "modal_size md_size" }, [
        _c(
          "a",
          {
            staticClass: "ui_close",
            attrs: { href: "javascript:", type: "button" },
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          },
          [_c("span", { staticClass: "sr_only" })]
        ),
        _vm._v(" "),
        "I" === _vm.dispType
          ? _c("dl", { staticClass: "modal_content" }, [
              _c("dt", { staticClass: "ellipsis" }, [
                _c("i", [
                  _vm._v(
                    "China " +
                      _vm._s(_vm.$t("FIELD.GLOBAL.INQUIRY.TYPE")) +
                      " " +
                      _vm._s(_vm.$t("FIELD.SURVEY.SUMMARY.LANG"))
                  )
                ])
              ]),
              _vm._v(" "),
              _c("dd", [
                _c("div", { staticClass: "grid_wrap only_grid" }, [
                  _c("table", { staticClass: "grid_table" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("thead", [
                      _c("tr", [
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.INQUIRY1")))
                        ]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("FIELD.CHINA.INQUIRY1")))
                        ]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.INQUIRY2")))
                        ]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("FIELD.CHINA.INQUIRY2")))
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      { staticClass: "text_center" },
                      _vm._l(_vm.inquiryList, function(item) {
                        return _c(
                          "tr",
                          { key: _vm.pageName + item.EN_INQ1 + item.EN_INQ2 },
                          [
                            _c("td", [_vm._v(_vm._s(item.EN_INQ1))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(item.CN_INQ1))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(item.EN_INQ2))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(item.CN_INQ2))])
                          ]
                        )
                      }),
                      0
                    )
                  ])
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        "C" === _vm.dispType
          ? _c("dl", { staticClass: "modal_content" }, [
              _c("dt", { staticClass: "ellipsis" }, [
                _c("i", [
                  _vm._v(
                    "China " +
                      _vm._s(_vm.$t("FIELD.GLOBAL.INQUIRY.TYPE")) +
                      " " +
                      _vm._s(_vm.$t("FIELD.SURVEY.SUMMARY.LANG"))
                  )
                ])
              ]),
              _vm._v(" "),
              _c("dd", [
                _c("div", { staticClass: "grid_wrap only_grid" }, [
                  _c("table", { staticClass: "grid_table" }, [
                    _vm._m(1),
                    _vm._v(" "),
                    _c("thead", [
                      _c("tr", [
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.CATEGORY1")))
                        ]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("FIELD.CHINA.CATEGORY1")))
                        ]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.CATEGORY2")))
                        ]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("FIELD.CHINA.CATEGORY2")))
                        ]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.CATEGORY3")))
                        ]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("FIELD.CHINA.CATEGORY3")))
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      { staticClass: "text_center" },
                      _vm._l(_vm.categoryList, function(item) {
                        return _c(
                          "tr",
                          {
                            key:
                              _vm.pageName +
                              item.EN_CAT1 +
                              item.EN_CAT2 +
                              item.EN_CAT3
                          },
                          [
                            _c("td", [_vm._v(_vm._s(item.EN_CAT1))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(item.CN_CAT1))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(item.EN_CAT2))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(item.CN_CAT2))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(item.EN_CAT3))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(item.CN_CAT3))])
                          ]
                        )
                      }),
                      0
                    )
                  ])
                ])
              ])
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "25%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "25%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "25%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "25%" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "15%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "15%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "15%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "15%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "15%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3d8c1d4e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d8c1d4e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/faq/popup/searchZHPopup.vue
// module id = fc75
// module chunks = 0